import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the gcIllustrationPage state domain
 */
const selectEspIllustrationPageDomain = state =>
  state.get('espIllustrationPage', initialState);

/**
 * Other specific selectors
 */
const makeSelectLifeAssured = () =>
  createSelector(selectEspIllustrationPageDomain, substate =>
    substate.get('lifeAssured').toJS(),
  );

const makeSelectChildLifeAssured = () =>
  createSelector(selectEspIllustrationPageDomain, substate =>
    substate.get('childDetails').toJS(),
  );
const makeSelectInitialLifeAssured = () =>
  createSelector(selectEspIllustrationPageDomain, substate =>
    substate.get('initialLifeAssured').toJS(),
  );

const makeSelectError = () =>
  createSelector(selectEspIllustrationPageDomain, substate =>
    substate.get('errorData').toJS(),
  );

const makeSelectConfig = () =>
  createSelector(selectEspIllustrationPageDomain, substate =>
    substate.get('gcConfig').toJS(),
  );

const makeSelectBiTableValues = () =>
  createSelector(selectEspIllustrationPageDomain, substate =>
    substate.get('biTableValues').toJS(),
  );

const makeSelectBiTableValues1 = () =>
  createSelector(selectEspIllustrationPageDomain, substate =>
    substate.get('biTableValues1').toJS(),
  );

const makeSelectFiaCharge = () =>
  createSelector(selectEspIllustrationPageDomain, substate =>
    substate.get('fiaData').toJS(),
  );

const makeSelectProductConfig = () =>
  createSelector(selectEspIllustrationPageDomain, substate =>
    substate.get('productConfig').toJS(),
  );

const makeSelectProductConfig2 = () =>
  createSelector(selectEspIllustrationPageDomain, substate =>
    substate.get('productConfig2').toJS(),
  );

const makeSelectQuoteId = () =>
  createSelector(selectEspIllustrationPageDomain, substate =>
    substate.get('quoteId'),
  );

const makeSelectApplicationId = () =>
  createSelector(selectEspIllustrationPageDomain, substate =>
    substate.get('applicationId'),
  );

const makeSelectBiPdf = () =>
  createSelector(selectEspIllustrationPageDomain, substate =>
    substate.get('benefitIllustrationPdf'),
  );
const makeSelectBiPdf1 = () =>
  createSelector(selectEspIllustrationPageDomain, substate =>
    substate.get('benefitIllustrationPdf1'),
  );

const makeSelectStatus = () =>
  createSelector(selectEspIllustrationPageDomain, substate =>
    substate.get('status'),
  );

const makeSelectReferenceNumber = () =>
  createSelector(selectEspIllustrationPageDomain, substate =>
    substate.get('referenceNumber'),
  );

const makeSelectCloneStatus = () =>
  createSelector(selectEspIllustrationPageDomain, substate =>
    substate.get('successClone'),
  );

const makeSelectemailSentStatus = () =>
  createSelector(selectEspIllustrationPageDomain, substate =>
    substate.get('emailSent'),
  );

const makeSelectEmailErrorMessage = () =>
  createSelector(selectEspIllustrationPageDomain, substate =>
    substate.get('emailErrorMessage'),
  );

const makeSelectCoverages2 = () =>
  createSelector(selectEspIllustrationPageDomain, substate =>
    substate.get('coverages2').toJS(),
  );

export {
  selectEspIllustrationPageDomain,
  makeSelectLifeAssured,
  makeSelectChildLifeAssured,
  makeSelectProductConfig,
  makeSelectFiaCharge,
  makeSelectConfig,
  makeSelectError,
  makeSelectQuoteId,
  makeSelectApplicationId,
  makeSelectBiPdf,
  makeSelectStatus,
  makeSelectReferenceNumber,
  makeSelectInitialLifeAssured,
  makeSelectBiTableValues,
  makeSelectBiTableValues1,
  makeSelectCloneStatus,
  makeSelectemailSentStatus,
  makeSelectEmailErrorMessage,
  makeSelectProductConfig2,
  makeSelectBiPdf1,
  makeSelectCoverages2,
};
